import { IGetAllClientsItemDto } from '../../../entities/user/domain/user.types';
import { capitalizeFirstLetter } from '../../../shared/helpers/base.helpers';

function defineClientName(client: IGetAllClientsItemDto): string {
  const companyName = capitalizeFirstLetter(client.companyName || '');
  return companyName || 'Unknown Client';
}

export function formSelectCardProps(clients: IGetAllClientsItemDto[]) {
  const selectCardProps = clients.map(client => {
    const name = defineClientName(client);
    return { clientId: client.id, clientName: name, key: client.id };
  });
  return selectCardProps;
}

export const transformUsersDataIntoOption = (clients: IGetAllClientsItemDto[]) => {
  return clients.map(client => {
    const companyName = capitalizeFirstLetter(client.companyName || '');
    return {
      label: companyName || 'Unknown Client',
      value: client.id,
    };
  });
};
